import { kbOneTrustInitService } from "./oneTrust.service";

export function appInitializer(kbOneTrustInitService: kbOneTrustInitService): Function {
  return () => {
    if (typeof window !== 'undefined') {
      kbOneTrustInitService.load();
      kbOneTrustInitService.consent();
      kbOneTrustInitService.translate();
    }
  }

}

